(function() {
	'use strict';

	angular.module('insurancerequestApp').controller('InsuranceRequestController',
			InsuranceRequestController);

	InsuranceRequestController.$inject = [ '$scope', '$state', '$stateParams',
			'$base64', '$window','CONST_INSURANCE_REQUEST', 'InsuranceRequestService', 'CommonService',
			'$http', '$log', 'Upload', 'AlertService','EVENT',
			'authExpiredInterceptor', '$uibModal' ];

	function InsuranceRequestController($scope, $state, $stateParams, $base64,
			$window, CONST_INSURANCE_REQUEST, InsuranceRequestService, CommonService, $http, $log, Upload,
			AlertService,EVENT, authExpiredInterceptor, $uibModal) {
		var insurancerequestCtr = this;
		insurancerequestCtr.options = [];
		insurancerequestCtr.options.TVVAD = '0';
		insurancerequestCtr.insuranceRequest = [];
		insurancerequestCtr.checkAgntNumSelected = false;
		insurancerequestCtr.CONST_INSURANCE_REQUEST = CONST_INSURANCE_REQUEST;
		var param = $stateParams;
		$scope.loading = false;
				
		insurancerequestCtr.changeOptions = function (options) {
			// Trường hợp AgntNum được select
			if (options == insurancerequestCtr.CONST_INSURANCE_REQUEST.TVV) {
				insurancerequestCtr.insuranceRequest.hrNum = '';
				insurancerequestCtr.insuranceRequest.reason = '';
				insurancerequestCtr.checkAgntNumSelected = false;
			} else {
				insurancerequestCtr.insuranceRequest.agntNum = '';
				insurancerequestCtr.checkAgntNumSelected = true;
			}
		};
		
		insurancerequestCtr.create = function() {
			insurancerequestCtr.insuranceRequestDTO.hrNum = insurancerequestCtr.insuranceRequest.hrNum;
			insurancerequestCtr.insuranceRequestDTO.reason = insurancerequestCtr.insuranceRequest.reason;
			insurancerequestCtr.insuranceRequestDTO.agntNum = insurancerequestCtr.insuranceRequest.agntNum;
			
			InsuranceRequestService.post({uri : 'doCreateInsuranceRequest'} , insurancerequestCtr.insuranceRequestDTO).$promise.then(function(result) {				
				if (result.flagError != null && result.flagError == 0) {
					$state.go($state.current, {}, {reload: true});
				} else {
					$scope.loading = false;
				}
			}, function(error) {
				if(error.status == '403') {
					$scope.addAlert('Văn phòng không được thao tác chức năng này .Vui lòng chọn văn phòng khác!','error');
				}
				$scope.loading = false;
			});
		}
		
		insurancerequestCtr.cancel = function() {
			window.location.href = GLOBAL_URL
			+ insurancerequestCtr.CONST_INSURANCE_REQUEST.URL_MENU;
		}
	}
})();
